// import React, { useState, useEffect } from "react";
// import { createPortal } from "react-dom";
// import axios from "axios";
// import {
//   RiAddLine,
//   RiSearchLine,
//   RiCloseLine,
//   RiEditLine,
//   RiDeleteBinLine,
//   RiCheckLine,
//   RiErrorWarningLine,
//   RiRefreshLine,
//   RiUserLine,
//   RiPhoneLine,
//   RiMailLine,
//   RiMapPinLine,
//   RiPriceTag3Line,
//   RiStore2Line,
//   RiListCheck2,
//   RiFileTextLine,
// } from "react-icons/ri";
// import { AiOutlineLoading3Quarters } from "react-icons/ai";

// const VENDOR_URL = `${process.env.REACT_APP_API_URL}/branding-vendor`;
// const CATEGORY_URL = `${process.env.REACT_APP_API_URL}/vendor-category`;

// const defaultForm = {
//   name: "",
//   categories: [],
//   contactPerson: "",
//   phone: "",
//   email: "",
//   address: "",
// };

// /* ─────────────────────────── tiny helpers ─────────────────────────── */

// const Spinner = () => (
//   <AiOutlineLoading3Quarters className="animate-spin w-4 h-4" />
// );

// const Toast = ({ message, type, onClose }) => {
//   useEffect(() => {
//     const t = setTimeout(onClose, 3500);
//     return () => clearTimeout(t);
//   }, []);
//   return (
//     <div
//       className={`fixed bottom-6 right-6 z-50 flex items-center gap-3 px-5 py-3 rounded-xl shadow-xl text-sm font-medium
//       ${
//         type === "success"
//           ? "bg-emerald-50 border border-emerald-200 text-emerald-800"
//           : "bg-red-50 border border-red-200 text-red-800"
//       }`}
//     >
//       {type === "success" ? (
//         <RiCheckLine className="w-4 h-4 text-emerald-500" />
//       ) : (
//         <RiErrorWarningLine className="w-4 h-4 text-red-500" />
//       )}
//       <span>{message}</span>
//       <button
//         onClick={onClose}
//         className="ml-2 opacity-50 hover:opacity-100 transition"
//       >
//         <RiCloseLine className="w-4 h-4" />
//       </button>
//     </div>
//   );
// };

// const Modal = ({ title, onClose, children }) =>
//   createPortal(
//     <div className="fixed inset-0 z-40 flex items-center justify-center">
//       <div
//         className="absolute inset-0 bg-blue-950/40 backdrop-blur-sm"
//         onClick={onClose}
//       />
//       <div className="relative z-10 w-full max-w-2xl mx-4 bg-white border border-blue-100 rounded-2xl shadow-2xl overflow-hidden">
//         <div className="flex items-center justify-between px-6 py-4 border-b border-blue-100 bg-blue-50">
//           <h2 className="text-base font-semibold text-blue-900 flex items-center gap-2">
//             {title}
//           </h2>
//           <button
//             onClick={onClose}
//             className="text-blue-400 hover:text-blue-700 transition rounded-lg p-1 hover:bg-blue-100"
//           >
//             <RiCloseLine className="w-5 h-5" />
//           </button>
//         </div>
//         <div className="p-6 max-h-[80vh] overflow-y-auto bg-white">
//           {children}
//         </div>
//       </div>
//     </div>,
//     document.body,
//   );

// /* ─────────────────────────── field map ─────────────────────────── */

// const fieldIconMap = {
//   name: RiStore2Line,
//   contactPerson: RiUserLine,
//   phone: RiPhoneLine,
//   email: RiMailLine,
//   address: RiMapPinLine,
// };

// const Field = ({
//   label,
//   name,
//   value,
//   onChange,
//   type = "text",
//   placeholder,
// }) => {
//   const Icon = fieldIconMap[name] || RiFileTextLine;
//   return (
//     <div className="flex flex-col gap-1.5">
//       <label className="text-xs font-semibold text-blue-700 uppercase tracking-widest">
//         {label}
//       </label>
//       <div className="relative">
//         <Icon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-blue-300" />
//         <input
//           type={type}
//           name={name}
//           value={value}
//           onChange={onChange}
//           placeholder={placeholder || label}
//           className="w-full bg-blue-50/60 border border-blue-200 rounded-lg pl-9 pr-3 py-2.5 text-sm text-slate-800 placeholder-blue-300 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition"
//         />
//       </div>
//     </div>
//   );
// };

// const CategorySelect = ({ value, onChange, categories }) => (
//   <div className="flex flex-col gap-1.5">
//     <label className="text-xs font-semibold text-blue-700 uppercase tracking-widest">
//       Category <span className="text-red-400">*</span>
//     </label>
//     <div className="relative">
//       <RiPriceTag3Line className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-blue-300 pointer-events-none" />
//       <select
//         name="category"
//         value={value}
//         onChange={onChange}
//         className="w-full bg-blue-50/60 border border-blue-200 rounded-lg pl-9 pr-3 py-2.5 text-sm text-slate-800 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition appearance-none"
//       >
//         <option value="">Select a category…</option>
//         {categories.map((cat) => (
//           <option key={cat._id} value={cat._id}>
//             {cat.name}
//           </option>
//         ))}
//       </select>
//     </div>
//   </div>
// );

// const MultiCategorySelect = ({ label, name, value, onChange, categories }) => {
//   const [isOpen, setIsOpen] = useState(false);
//   const dropdownRef = React.useRef(null);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsOpen(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);

//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const toggleOption = (categoryId) => {
//     const newValue = value.includes(categoryId)
//       ? value.filter((v) => v !== categoryId)
//       : [...value, categoryId];

//     onChange({
//       target: {
//         name,
//         value: newValue,
//       },
//     });
//   };

//   const removeOption = (categoryId) => {
//     onChange({
//       target: {
//         name,
//         value: value.filter((v) => v !== categoryId),
//       },
//     });
//   };

//   const selectedLabels = value
//     .map((id) => {
//       const cat = categories.find((c) => c._id === id);
//       return cat ? cat.name : "";
//     })
//     .filter(Boolean);

//   return (
//     <div className="flex flex-col gap-1.5" ref={dropdownRef}>
//       <label className="text-xs font-semibold text-blue-700 uppercase tracking-widest">
//         {label}
//       </label>

//       <div className="relative">
//         <RiPriceTag3Line className="absolute left-3 top-3 w-4 h-4 text-blue-300 pointer-events-none z-10" />

//         <div
//           onClick={() => setIsOpen(!isOpen)}
//           className="w-full bg-blue-50/60 border border-blue-200 rounded-lg pl-9 pr-3 py-2.5 text-sm text-slate-800 cursor-pointer min-h-[42px]"
//         >
//           {selectedLabels.length ? (
//             <div className="flex flex-wrap gap-1.5">
//               {selectedLabels.map((label, idx) => (
//                 <span
//                   key={idx}
//                   className="inline-flex items-center gap-1 px-2 py-0.5 bg-blue-100 text-blue-700 rounded-md text-xs"
//                 >
//                   {label}

//                   <button
//                     type="button"
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       removeOption(value[idx]);
//                     }}
//                   >
//                     <RiCloseLine className="w-3 h-3" />
//                   </button>
//                 </span>
//               ))}
//             </div>
//           ) : (
//             <span className="text-blue-300">Select Categories</span>
//           )}
//         </div>

//         {isOpen && (
//           <div className="absolute z-20 w-full mt-1 bg-white border border-blue-200 rounded-lg shadow-lg max-h-48 overflow-y-auto">
//             {categories.map((cat) => (
//               <label
//                 key={cat._id}
//                 className="flex items-center gap-2 px-3 py-2 hover:bg-blue-50 cursor-pointer text-sm"
//               >
//                 <input
//                   type="checkbox"
//                   checked={value.includes(cat._id)}
//                   onChange={() => toggleOption(cat._id)}
//                   className="rounded border-blue-300 text-blue-600"
//                 />

//                 <span>{cat.name}</span>
//               </label>
//             ))}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// /* ─────────────────────────── form body ─────────────────────────── */

// const formFields = [
//   { label: "Vendor Name", name: "name" },
//   { label: "Contact Person", name: "contactPerson" },
//   { label: "Phone", name: "phone", type: "tel" },
//   { label: "Email", name: "email", type: "email" },
//   { label: "Address", name: "address" },
// ];

// const FormBody = ({ form, handleChange, categories }) => (
//   <div className="grid grid-cols-2 gap-4 mb-6">
//     {/* Category spans full width */}
//     <div className="col-span-2">
//       <MultiCategorySelect
//         label="Categories (Select Multiple)"
//         name="categories"
//         value={form.categories}
//         onChange={handleChange}
//         categories={categories}
//       />
//       {form.categories.length > 1 && (
//         <div className="col-span-2">
//           <div className="p-3 bg-blue-50 rounded-lg border border-blue-100">
//             <p className="text-xs font-semibold text-blue-700 mb-1">
//               Will create {form.categories.length} separate vendors
//             </p>

//             <p className="text-xs text-blue-600">
//               One vendor record will be created for each selected category.
//             </p>
//           </div>
//         </div>
//       )}
//     </div>
//     {formFields.map((f) => (
//       <Field key={f.name} {...f} value={form[f.name]} onChange={handleChange} />
//     ))}
//   </div>
// );

// /* ─────────────────────────── main component ─────────────────────────── */

// export default function BrandingVendors() {
//   const [vendors, setVendors] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [actionLoading, setActionLoading] = useState(false);
//   const [modal, setModal] = useState(null);
//   const [selected, setSelected] = useState(null);
//   const [form, setForm] = useState(defaultForm);
//   const [toast, setToast] = useState(null);
//   const [search, setSearch] = useState("");
//   const [filterCategory, setFilterCategory] = useState("");

//   const notify = (message, type = "success") => setToast({ message, type });

//   /* fetch categories once */
//   const fetchCategories = async () => {
//     try {
//       const res = await axios.get(`${CATEGORY_URL}/`);
//       setCategories(res.data?.data || res.data || []);
//     } catch {
//       notify("Failed to fetch categories", "error");
//     }
//   };

//   /* fetch vendors — supports server-side category filter */
//   const fetchVendors = async () => {
//     setLoading(true);
//     try {
//       const params = {};
//       if (filterCategory) params.category = filterCategory;
//       if (search) params.search = search;
//       const res = await axios.get(`${VENDOR_URL}/`, { params });
//       setVendors(res.data?.data || res.data || []);
//     } catch {
//       notify("Failed to fetch vendors", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchCategories();
//   }, []);

//   useEffect(() => {
//     fetchVendors();
//   }, [filterCategory]);

//   /* modal helpers */
//   const openCreate = () => {
//     setForm(defaultForm);
//     setModal("create");
//   };
//   const openEdit = (v) => {
//     setSelected(v);
//     setForm({
//       name: v.name || "",
//       categories: [v.category?._id || v.category || ""],
//       contactPerson: v.contactPerson || "",
//       phone: v.phone || "",
//       email: v.email || "",
//       address: v.address || "",
//     });
//     setModal("edit");
//   };
//   const openDelete = (v) => {
//     setSelected(v);
//     setModal("delete");
//   };
//   const closeModal = () => {
//     setModal(null);
//     setSelected(null);
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     setForm((f) => ({
//       ...f,
//       [name]: value,
//     }));
//   };

//   /* CRUD */
//   const handleCreate = async () => {
//     if (!form.name.trim() || !form.categories || form.categories.length === 0) {
//       notify("Vendor name and category are required", "error");
//       return;
//     }
//     setActionLoading(true);
//     try {
//       await axios.post(`${VENDOR_URL}/bulk`, {
//         name: form.name,
//         categories: form.categories,
//         contactPerson: form.contactPerson,
//         phone: form.phone,
//         email: form.email,
//         address: form.address,
//       });
//       notify("Vendor created successfully");
//       fetchVendors();
//       closeModal();
//     } catch (err) {
//       notify(
//         err?.response?.data?.message || "Failed to create vendor",
//         "error",
//       );
//     } finally {
//       setActionLoading(false);
//     }
//   };

//   const handleUpdate = async () => {
//     if (!form.name.trim() || !form.categories || form.categories.length === 0) {
//       notify("Vendor name and category are required", "error");
//       return;
//     }
//     setActionLoading(true);
//     try {
//       await axios.put(`${VENDOR_URL}/${selected._id}`, {
//         name: form.name,
//         category: form.categories[0],
//         contactPerson: form.contactPerson,
//         phone: form.phone,
//         email: form.email,
//         address: form.address,
//       });
//       notify("Vendor updated successfully");
//       fetchVendors();
//       closeModal();
//     } catch (err) {
//       notify(
//         err?.response?.data?.message || "Failed to update vendor",
//         "error",
//       );
//     } finally {
//       setActionLoading(false);
//     }
//   };

//   const handleDelete = async () => {
//     setActionLoading(true);
//     try {
//       await axios.delete(`${VENDOR_URL}/${selected._id}`);
//       notify("Vendor deleted successfully");
//       fetchVendors();
//       closeModal();
//     } catch {
//       notify("Failed to delete vendor", "error");
//     } finally {
//       setActionLoading(false);
//     }
//   };

//   /* client-side search filter (name already filtered server-side if passed,
//      but we also support instant local filtering when not using server search) */
//   const filtered = vendors.filter(
//     (v) =>
//       (v.name || "").toLowerCase().includes(search.toLowerCase()) ||
//       (v.email || "").toLowerCase().includes(search.toLowerCase()) ||
//       (v.contactPerson || "").toLowerCase().includes(search.toLowerCase()),
//   );

//   const tableHeaders = [
//     { label: "#" },
//     { label: "Vendor Name", Icon: RiStore2Line },
//     { label: "Category", Icon: RiPriceTag3Line },
//     { label: "Contact", Icon: RiUserLine },
//     { label: "Phone", Icon: RiPhoneLine },
//     { label: "Email", Icon: RiMailLine },
//     { label: "Address", Icon: RiMapPinLine },
//     { label: "Actions" },
//   ];

//   return (
//     <div className="min-h-screen bg-white text-slate-800">
//       {/* ── Header ── */}
//       <header className="bg-white border-b border-blue-100 sticky top-0 z-30 shadow-sm">
//         <div className="w-full mx-auto px-6 py-3.5 flex items-center justify-between gap-4 flex-wrap">
//           <div className="flex items-center gap-3">
//             <div className="w-10 h-10 rounded-xl bg-blue-600 flex items-center justify-center text-white shadow-md shadow-blue-200">
//               <RiStore2Line className="w-5 h-5" />
//             </div>
//             <div>
//               <h1 className="text-base font-bold text-blue-800 tracking-tight">
//                 Branding Vendors
//               </h1>
//               <p className="text-[11px] text-blue-400 tracking-widest uppercase">
//                 Vendor Management
//               </p>
//             </div>
//           </div>

//           <div className="flex items-center gap-3 flex-wrap">
//             {/* Category filter */}
//             <div className="relative">
//               <RiPriceTag3Line className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-blue-400 pointer-events-none" />
//               <select
//                 value={filterCategory}
//                 onChange={(e) => setFilterCategory(e.target.value)}
//                 className="bg-blue-50 border border-blue-200 rounded-lg pl-9 pr-3 py-2 text-sm text-slate-700 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 w-44 transition appearance-none"
//               >
//                 <option value="">All Categories</option>
//                 {categories.map((cat) => (
//                   <option key={cat._id} value={cat._id}>
//                     {cat.name}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             {/* Search */}
//             <div className="relative">
//               <RiSearchLine className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-blue-400" />
//               <input
//                 value={search}
//                 onChange={(e) => setSearch(e.target.value)}
//                 placeholder="Search vendors..."
//                 className="bg-blue-50 border border-blue-200 rounded-lg pl-9 pr-3 py-2 text-sm text-slate-700 placeholder-blue-300 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 w-52 transition"
//               />
//             </div>

//             {/* Refresh */}
//             <button
//               onClick={fetchVendors}
//               disabled={loading}
//               title="Refresh"
//               className="w-9 h-9 flex items-center justify-center rounded-lg border border-blue-200 text-blue-400 hover:text-blue-600 hover:bg-blue-50 transition disabled:opacity-50"
//             >
//               <RiRefreshLine
//                 className={`w-4 h-4 ${loading ? "animate-spin" : ""}`}
//               />
//             </button>

//             <button
//               onClick={openCreate}
//               className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold text-sm px-4 py-2 rounded-lg transition-all shadow-md shadow-blue-200"
//             >
//               <RiAddLine className="w-4 h-4" />
//               Add Vendor
//             </button>
//           </div>
//         </div>
//       </header>

//       {/* ── Table ── */}
//       <div className="w-full mx-auto px-6 pt-6 pb-10">
//         <div className="bg-white border border-blue-100 rounded-2xl overflow-hidden shadow-sm">
//           <div className="px-5 py-3.5 border-b border-blue-50 bg-blue-50/50 flex items-center justify-between">
//             <span className="text-sm font-semibold text-blue-800 flex items-center gap-2">
//               <RiListCheck2 className="w-4 h-4 text-blue-500" />
//               All Vendors
//             </span>
//             <span className="text-xs text-blue-400">
//               {filtered.length} record{filtered.length !== 1 ? "s" : ""}
//             </span>
//           </div>

//           <div className="overflow-x-auto">
//             <table className="w-full text-sm">
//               <thead>
//                 <tr className="border-b border-blue-100 bg-blue-50/30">
//                   {tableHeaders.map(({ label, Icon }) => (
//                     <th key={label} className="px-4 py-3 text-left">
//                       <span className="flex items-center gap-1.5 text-xs font-semibold text-blue-500 uppercase tracking-widest whitespace-nowrap">
//                         {Icon && <Icon className="w-3.5 h-3.5" />}
//                         {label}
//                       </span>
//                     </th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {loading ? (
//                   <tr>
//                     <td colSpan={8} className="py-20 text-center">
//                       <div className="flex flex-col items-center gap-3 text-blue-400">
//                         <AiOutlineLoading3Quarters className="w-7 h-7 animate-spin text-blue-500" />
//                         <span className="text-sm">Loading vendors…</span>
//                       </div>
//                     </td>
//                   </tr>
//                 ) : filtered.length === 0 ? (
//                   <tr>
//                     <td colSpan={8} className="py-20 text-center">
//                       <div className="flex flex-col items-center gap-3">
//                         <div className="w-14 h-14 rounded-full bg-blue-50 border border-blue-100 flex items-center justify-center">
//                           <RiStore2Line className="w-7 h-7 text-blue-300" />
//                         </div>
//                         <span className="text-sm text-slate-400">
//                           {search || filterCategory
//                             ? "No vendors match your filters."
//                             : "No vendors found. Add one to get started."}
//                         </span>
//                       </div>
//                     </td>
//                   </tr>
//                 ) : (
//                   filtered.map((vendor, i) => (
//                     <tr
//                       key={vendor._id || i}
//                       className="border-b border-blue-50 hover:bg-blue-50/50 transition group"
//                     >
//                       <td className="px-4 py-3 text-slate-400 text-xs font-medium">
//                         {i + 1}
//                       </td>
//                       <td className="px-4 py-3 font-semibold text-slate-800 whitespace-nowrap">
//                         <div className="flex items-center gap-2">
//                           <div className="w-7 h-7 rounded-lg bg-blue-600 flex items-center justify-center text-white text-xs font-bold shadow-sm shadow-blue-200 flex-shrink-0">
//                             {(vendor.name || "?")[0].toUpperCase()}
//                           </div>
//                           {vendor.name || "—"}
//                         </div>
//                       </td>
//                       <td className="px-4 py-3">
//                         {vendor.category ? (
//                           <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-blue-50 border border-blue-200 text-blue-600 text-xs font-semibold whitespace-nowrap">
//                             <RiPriceTag3Line className="w-3 h-3" />
//                             {vendor.category?.name || vendor.category}
//                           </span>
//                         ) : (
//                           <span className="text-slate-300 text-xs italic">
//                             —
//                           </span>
//                         )}
//                       </td>
//                       <td className="px-4 py-3 text-slate-600 whitespace-nowrap">
//                         {vendor.contactPerson || "—"}
//                       </td>
//                       <td className="px-4 py-3 text-slate-500 whitespace-nowrap">
//                         {vendor.phone || "—"}
//                       </td>
//                       <td className="px-4 py-3 text-slate-500 whitespace-nowrap">
//                         {vendor.email || "—"}
//                       </td>
//                       <td className="px-4 py-3 text-slate-500 max-w-[180px] truncate">
//                         {vendor.address || "—"}
//                       </td>
//                       <td className="px-4 py-3">
//                         <div className="flex gap-2">
//                           <button
//                             onClick={() => openEdit(vendor)}
//                             className="flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-lg bg-blue-50 border border-blue-200 text-blue-600 hover:bg-blue-100 font-semibold transition"
//                           >
//                             <RiEditLine className="w-3.5 h-3.5" /> Edit
//                           </button>
//                           <button
//                             onClick={() => openDelete(vendor)}
//                             className="flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-lg bg-red-50 border border-red-200 text-red-500 hover:bg-red-100 font-semibold transition"
//                           >
//                             <RiDeleteBinLine className="w-3.5 h-3.5" /> Delete
//                           </button>
//                         </div>
//                       </td>
//                     </tr>
//                   ))
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>

//       {/* ── Create Modal ── */}
//       {modal === "create" && (
//         <Modal
//           title={
//             <>
//               <RiAddLine className="w-5 h-5 text-blue-500" /> Add New Vendor
//             </>
//           }
//           onClose={closeModal}
//         >
//           <FormBody
//             form={form}
//             handleChange={handleChange}
//             categories={categories}
//           />
//           <div className="flex justify-end gap-3 pt-2 border-t border-blue-50">
//             <button
//               onClick={closeModal}
//               className="flex items-center gap-1.5 px-5 py-2 rounded-lg text-sm text-slate-500 hover:text-slate-700 border border-slate-200 hover:bg-slate-50 transition"
//             >
//               <RiCloseLine className="w-4 h-4" /> Cancel
//             </button>
//             <button
//               onClick={handleCreate}
//               disabled={actionLoading}
//               className="flex items-center gap-2 px-5 py-2 rounded-lg text-sm font-semibold bg-blue-600 hover:bg-blue-700 text-white transition shadow-md shadow-blue-200 disabled:opacity-60"
//             >
//               {actionLoading ? (
//                 <Spinner />
//               ) : (
//                 <RiCheckLine className="w-4 h-4" />
//               )}
//               Create{" "}
//               {form.categories.length > 0 ? `(${form.categories.length})` : ""}{" "}
//               Vendor
//               {form.categories.length !== 1 ? "s" : ""}
//             </button>
//           </div>
//         </Modal>
//       )}

//       {/* ── Edit Modal ── */}
//       {modal === "edit" && (
//         <Modal
//           title={
//             <>
//               <RiEditLine className="w-5 h-5 text-blue-500" /> Edit —{" "}
//               {selected?.name}
//             </>
//           }
//           onClose={closeModal}
//         >
//           <FormBody
//             form={form}
//             handleChange={handleChange}
//             categories={categories}
//           />
//           <div className="flex justify-end gap-3 pt-2 border-t border-blue-50">
//             <button
//               onClick={closeModal}
//               className="flex items-center gap-1.5 px-5 py-2 rounded-lg text-sm text-slate-500 hover:text-slate-700 border border-slate-200 hover:bg-slate-50 transition"
//             >
//               <RiCloseLine className="w-4 h-4" /> Cancel
//             </button>
//             <button
//               onClick={handleUpdate}
//               disabled={actionLoading}
//               className="flex items-center gap-2 px-5 py-2 rounded-lg text-sm font-semibold bg-blue-600 hover:bg-blue-700 text-white transition shadow-md shadow-blue-200 disabled:opacity-60"
//             >
//               {actionLoading ? (
//                 <Spinner />
//               ) : (
//                 <RiCheckLine className="w-4 h-4" />
//               )}
//               Save Changes
//             </button>
//           </div>
//         </Modal>
//       )}

//       {/* ── Delete Modal ── */}
//       {modal === "delete" && (
//         <Modal
//           title={
//             <>
//               <RiDeleteBinLine className="w-5 h-5 text-red-500" /> Confirm
//               Deletion
//             </>
//           }
//           onClose={closeModal}
//         >
//           <div className="text-center py-4">
//             <div className="w-16 h-16 rounded-full bg-red-50 border border-red-100 flex items-center justify-center mx-auto mb-4">
//               <RiErrorWarningLine className="w-8 h-8 text-red-500" />
//             </div>
//             <p className="text-slate-700 font-semibold mb-1 text-base">
//               Delete <span className="text-red-500">{selected?.name}</span>?
//             </p>
//             <p className="text-slate-400 text-sm mb-6">
//               This action cannot be undone. This vendor will be permanently
//               removed.
//             </p>
//             <div className="flex justify-center gap-3">
//               <button
//                 onClick={closeModal}
//                 className="flex items-center gap-1.5 px-6 py-2 rounded-lg text-sm text-slate-500 border border-slate-200 hover:bg-slate-50 transition"
//               >
//                 <RiCloseLine className="w-4 h-4" /> Cancel
//               </button>
//               <button
//                 onClick={handleDelete}
//                 disabled={actionLoading}
//                 className="flex items-center gap-2 px-6 py-2 rounded-lg text-sm font-semibold bg-red-500 hover:bg-red-600 text-white transition shadow-md shadow-red-100 disabled:opacity-60"
//               >
//                 {actionLoading ? (
//                   <Spinner />
//                 ) : (
//                   <RiDeleteBinLine className="w-4 h-4" />
//                 )}
//                 Delete Vendor
//               </button>
//             </div>
//           </div>
//         </Modal>
//       )}

//       {toast && <Toast {...toast} onClose={() => setToast(null)} />}
//     </div>
//   );
// }

import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import axios from "axios";
import {
  RiAddLine,
  RiSearchLine,
  RiCloseLine,
  RiEditLine,
  RiDeleteBinLine,
  RiCheckLine,
  RiErrorWarningLine,
  RiRefreshLine,
  RiUserLine,
  RiPhoneLine,
  RiMailLine,
  RiMapPinLine,
  RiPriceTag3Line,
  RiStore2Line,
  RiListCheck2,
  RiFileTextLine,
  RiCheckboxCircleLine,
} from "react-icons/ri";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

const VENDOR_URL = `${process.env.REACT_APP_API_URL}/branding-vendor`;
const CATEGORY_URL = `${process.env.REACT_APP_API_URL}/vendor-category`;

const defaultForm = {
  name: "",
  categories: [],
  contactPerson: "",
  phone: "",
  email: "",
  address: "",
};

/* ─────────────────────────── tiny helpers ─────────────────────────── */

const Spinner = () => (
  <AiOutlineLoading3Quarters className="animate-spin w-4 h-4" />
);

const Toast = ({ message, type, onClose }) => {
  useEffect(() => {
    const t = setTimeout(onClose, 3500);
    return () => clearTimeout(t);
  }, []);
  return (
    <div
      className={`fixed bottom-6 right-6 z-50 flex items-center gap-3 px-5 py-3 rounded-xl shadow-xl text-sm font-medium
      ${
        type === "success"
          ? "bg-emerald-50 border border-emerald-200 text-emerald-800"
          : "bg-red-50 border border-red-200 text-red-800"
      }`}
    >
      {type === "success" ? (
        <RiCheckLine className="w-4 h-4 text-emerald-500" />
      ) : (
        <RiErrorWarningLine className="w-4 h-4 text-red-500" />
      )}
      <span>{message}</span>
      <button
        onClick={onClose}
        className="ml-2 opacity-50 hover:opacity-100 transition"
      >
        <RiCloseLine className="w-4 h-4" />
      </button>
    </div>
  );
};

const Modal = ({ title, onClose, children }) =>
  createPortal(
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div
        className="absolute inset-0 bg-blue-950/40 backdrop-blur-sm"
        onClick={onClose}
      />
      <div className="relative z-10 w-full max-w-2xl mx-4 bg-white border border-blue-100 rounded-2xl shadow-2xl overflow-hidden">
        <div className="flex items-center justify-between px-6 py-4 border-b border-blue-100 bg-blue-50">
          <h2 className="text-base font-semibold text-blue-900 flex items-center gap-2">
            {title}
          </h2>
          <button
            onClick={onClose}
            className="text-blue-400 hover:text-blue-700 transition rounded-lg p-1 hover:bg-blue-100"
          >
            <RiCloseLine className="w-5 h-5" />
          </button>
        </div>
        <div className="p-6 max-h-[80vh] overflow-y-auto bg-white">
          {children}
        </div>
      </div>
    </div>,
    document.body,
  );

/* ─────────────────────────── field map ─────────────────────────── */

const fieldIconMap = {
  name: RiStore2Line,
  contactPerson: RiUserLine,
  phone: RiPhoneLine,
  email: RiMailLine,
  address: RiMapPinLine,
};

const Field = ({
  label,
  name,
  value,
  onChange,
  type = "text",
  placeholder,
}) => {
  const Icon = fieldIconMap[name] || RiFileTextLine;
  return (
    <div className="flex flex-col gap-1.5">
      <label className="text-xs font-semibold text-blue-700 uppercase tracking-widest">
        {label}
      </label>
      <div className="relative">
        <Icon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-blue-300" />
        <input
          type={type}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder || label}
          className="w-full bg-blue-50/60 border border-blue-200 rounded-lg pl-9 pr-3 py-2.5 text-sm text-slate-800 placeholder-blue-300 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition"
        />
      </div>
    </div>
  );
};

const CategorySelect = ({ value, onChange, categories }) => (
  <div className="flex flex-col gap-1.5">
    <label className="text-xs font-semibold text-blue-700 uppercase tracking-widest">
      Category <span className="text-red-400">*</span>
    </label>
    <div className="relative">
      <RiPriceTag3Line className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-blue-300 pointer-events-none" />
      <select
        name="category"
        value={value}
        onChange={onChange}
        className="w-full bg-blue-50/60 border border-blue-200 rounded-lg pl-9 pr-3 py-2.5 text-sm text-slate-800 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition appearance-none"
      >
        <option value="">Select a category…</option>
        {categories.map((cat) => (
          <option key={cat._id} value={cat._id}>
            {cat.name}
          </option>
        ))}
      </select>
    </div>
  </div>
);

const MultiCategorySelect = ({ label, name, value, onChange, categories }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = React.useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleOption = (categoryId) => {
    const newValue = value.includes(categoryId)
      ? value.filter((v) => v !== categoryId)
      : [...value, categoryId];

    onChange({
      target: {
        name,
        value: newValue,
      },
    });
  };

  const removeOption = (categoryId) => {
    onChange({
      target: {
        name,
        value: value.filter((v) => v !== categoryId),
      },
    });
  };

  const selectedLabels = value
    .map((id) => {
      const cat = categories.find((c) => c._id === id);
      return cat ? cat.name : "";
    })
    .filter(Boolean);

  return (
    <div className="flex flex-col gap-1.5" ref={dropdownRef}>
      <label className="text-xs font-semibold text-blue-700 uppercase tracking-widest">
        {label}
      </label>

      <div className="relative">
        <RiPriceTag3Line className="absolute left-3 top-3 w-4 h-4 text-blue-300 pointer-events-none z-10" />

        <div
          onClick={() => setIsOpen(!isOpen)}
          className="w-full bg-blue-50/60 border border-blue-200 rounded-lg pl-9 pr-3 py-2.5 text-sm text-slate-800 cursor-pointer min-h-[42px]"
        >
          {selectedLabels.length ? (
            <div className="flex flex-wrap gap-1.5">
              {selectedLabels.map((label, idx) => (
                <span
                  key={idx}
                  className="inline-flex items-center gap-1 px-2 py-0.5 bg-blue-100 text-blue-700 rounded-md text-xs"
                >
                  {label}

                  <button
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      removeOption(value[idx]);
                    }}
                  >
                    <RiCloseLine className="w-3 h-3" />
                  </button>
                </span>
              ))}
            </div>
          ) : (
            <span className="text-blue-300">Select Categories</span>
          )}
        </div>

        {isOpen && (
          <div className="absolute z-20 w-full mt-1 bg-white border border-blue-200 rounded-lg shadow-lg max-h-48 overflow-y-auto">
            {categories.length === 0 ? (
              <div className="px-3 py-2 text-sm text-slate-400">
                No categories available
              </div>
            ) : (
              categories.map((cat) => (
                <label
                  key={cat._id}
                  className="flex items-center gap-2 px-3 py-2 hover:bg-blue-50 cursor-pointer text-sm"
                >
                  <input
                    type="checkbox"
                    checked={value.includes(cat._id)}
                    onChange={() => toggleOption(cat._id)}
                    className="rounded border-blue-300 text-blue-600"
                  />

                  <span>{cat.name}</span>
                </label>
              ))
            )}
          </div>
        )}
      </div>
    </div>
  );
};

/* ─────────────────────────── form body ─────────────────────────── */

const formFields = [
  { label: "Vendor Name", name: "name" },
  { label: "Contact Person", name: "contactPerson" },
  { label: "Phone", name: "phone", type: "tel" },
  { label: "Email", name: "email", type: "email" },
  { label: "Address", name: "address" },
];

const FormBody = ({
  form,
  handleChange,
  categories,
  existingCategoryNames,
}) => (
  <div className="grid grid-cols-2 gap-4 mb-6">
    {/* Category spans full width */}
    <div className="col-span-2 flex flex-col gap-4">
      {/* Show categories this vendor name already exists under */}
      {form.name.trim() && existingCategoryNames.length > 0 && (
        <div className="p-3 bg-amber-50 rounded-lg border border-amber-100">
          <p className="text-xs font-semibold text-amber-700 mb-1.5 flex items-center gap-1">
            <RiPriceTag3Line className="w-3.5 h-3.5" />"{form.name}" already
            exists for these categories:
          </p>
          <div className="flex flex-wrap gap-1.5">
            {existingCategoryNames.map((name, idx) => (
              <span
                key={idx}
                className="inline-flex items-center px-2 py-0.5 bg-amber-100 text-amber-700 rounded-md text-xs font-medium"
              >
                {name}
              </span>
            ))}
          </div>
          <p className="text-[11px] text-amber-600 mt-1.5">
            Choose from the remaining categories below to add this vendor to new
            categories.
          </p>
        </div>
      )}

      <MultiCategorySelect
        label="Categories (Select Multiple)"
        name="categories"
        value={form.categories}
        onChange={handleChange}
        categories={categories}
      />
      {form.categories.length > 1 && (
        <div className="p-3 bg-blue-50 rounded-lg border border-blue-100">
          <p className="text-xs font-semibold text-blue-700 mb-1 flex items-center gap-1">
            <RiCheckboxCircleLine className="w-3.5 h-3.5" />
            Will create {form.categories.length} separate vendors
          </p>

          <p className="text-xs text-blue-600">
            One vendor record will be created for each selected category.
          </p>
        </div>
      )}
    </div>
    {formFields.map((f) => (
      <Field key={f.name} {...f} value={form[f.name]} onChange={handleChange} />
    ))}
  </div>
);

/* ─────────────────────────── main component ─────────────────────────── */

export default function BrandingVendors() {
  const [vendors, setVendors] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);
  const [modal, setModal] = useState(null);
  const [selected, setSelected] = useState(null);
  const [form, setForm] = useState(defaultForm);
  const [toast, setToast] = useState(null);
  const [search, setSearch] = useState("");
  const [filterCategory, setFilterCategory] = useState("");

  const notify = (message, type = "success") => setToast({ message, type });

  /* fetch categories once */
  const fetchCategories = async () => {
    try {
      const res = await axios.get(`${CATEGORY_URL}/`);
      setCategories(res.data?.data || res.data || []);
    } catch {
      notify("Failed to fetch categories", "error");
    }
  };

  /* fetch vendors — supports server-side category filter */
  const fetchVendors = async () => {
    setLoading(true);
    try {
      const params = {};
      if (filterCategory) params.category = filterCategory;
      if (search) params.search = search;
      const res = await axios.get(`${VENDOR_URL}/`, { params });
      setVendors(res.data?.data || res.data || []);
    } catch {
      notify("Failed to fetch vendors", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  useEffect(() => {
    fetchVendors();
  }, [filterCategory]);

  /* ── derived data for category de-duplication ── */

  // All vendor records that already exist for the name typed in the form
  // (matched case-insensitively, ignoring surrounding whitespace)
  const normalizedFormName = form.name.trim().toLowerCase();
  const existingVendorRecords = normalizedFormName
    ? vendors.filter(
        (v) => (v.name || "").trim().toLowerCase() === normalizedFormName,
      )
    : [];

  // Category IDs this vendor name already has records for
  const existingCategoryIds = existingVendorRecords
    .map((v) => v.category?._id || v.category)
    .filter(Boolean);

  // In edit mode, keep the record's own current category selectable
  const currentEditCategoryId =
    modal === "edit" ? selected?.category?._id || selected?.category : null;

  // Only offer categories this vendor name doesn't already have
  // (except the one currently being edited, which stays visible/selectable)
  const remainingCategories = categories.filter(
    (c) =>
      c._id === currentEditCategoryId || !existingCategoryIds.includes(c._id),
  );

  // Names of categories this vendor name already exists under, for display
  const existingCategoryNames = existingVendorRecords
    .map((v) => v.category?.name)
    .filter(Boolean);

  /* modal helpers */
  const openCreate = () => {
    setForm(defaultForm);
    setModal("create");
  };
  const openEdit = (v) => {
    setSelected(v);
    setForm({
      name: v.name || "",
      categories: [v.category?._id || v.category || ""],
      contactPerson: v.contactPerson || "",
      phone: v.phone || "",
      email: v.email || "",
      address: v.address || "",
    });
    setModal("edit");
  };
  const openDelete = (v) => {
    setSelected(v);
    setModal("delete");
  };
  const closeModal = () => {
    setModal(null);
    setSelected(null);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((f) => ({
      ...f,
      [name]: value,
    }));
  };

  /* CRUD */
  const handleCreate = async () => {
    if (!form.name.trim() || !form.categories || form.categories.length === 0) {
      notify("Vendor name and category are required", "error");
      return;
    }
    setActionLoading(true);
    try {
      await axios.post(`${VENDOR_URL}/bulk`, {
        name: form.name,
        categories: form.categories,
        contactPerson: form.contactPerson,
        phone: form.phone,
        email: form.email,
        address: form.address,
      });
      notify("Vendor created successfully");
      fetchVendors();
      closeModal();
    } catch (err) {
      notify(
        err?.response?.data?.message || "Failed to create vendor",
        "error",
      );
    } finally {
      setActionLoading(false);
    }
  };

  const handleUpdate = async () => {
    if (!form.name.trim() || !form.categories || form.categories.length === 0) {
      notify("Vendor name and category are required", "error");
      return;
    }
    setActionLoading(true);
    try {
      const selectedCategories = form.categories;

      // If the record's original category is still selected, keep updating
      // that record. Otherwise, fall back to the first selected category.
      const keepCurrent = selectedCategories.includes(currentEditCategoryId);
      const updateCategoryId = keepCurrent
        ? currentEditCategoryId
        : selectedCategories[0];

      // Any other selected categories are newly added -> create as new vendor records
      const newCategories = selectedCategories.filter(
        (id) => id !== updateCategoryId,
      );

      // 1. Update the existing vendor record
      await axios.put(`${VENDOR_URL}/${selected._id}`, {
        name: form.name,
        category: updateCategoryId,
        contactPerson: form.contactPerson,
        phone: form.phone,
        email: form.email,
        address: form.address,
      });

      // 2. Create new vendor records for any additionally selected categories
      if (newCategories.length > 0) {
        await axios.post(`${VENDOR_URL}/bulk`, {
          name: form.name,
          categories: newCategories,
          contactPerson: form.contactPerson,
          phone: form.phone,
          email: form.email,
          address: form.address,
        });
      }

      notify(
        newCategories.length > 0
          ? `Vendor updated and added to ${newCategories.length} new categor${
              newCategories.length > 1 ? "ies" : "y"
            }`
          : "Vendor updated successfully",
      );
      fetchVendors();
      closeModal();
    } catch (err) {
      notify(
        err?.response?.data?.message || "Failed to update vendor",
        "error",
      );
    } finally {
      setActionLoading(false);
    }
  };

  const handleDelete = async () => {
    setActionLoading(true);
    try {
      await axios.delete(`${VENDOR_URL}/${selected._id}`);
      notify("Vendor deleted successfully");
      fetchVendors();
      closeModal();
    } catch {
      notify("Failed to delete vendor", "error");
    } finally {
      setActionLoading(false);
    }
  };

  /* client-side search filter (name already filtered server-side if passed,
     but we also support instant local filtering when not using server search) */
  const filtered = vendors.filter(
    (v) =>
      (v.name || "").toLowerCase().includes(search.toLowerCase()) ||
      (v.email || "").toLowerCase().includes(search.toLowerCase()) ||
      (v.contactPerson || "").toLowerCase().includes(search.toLowerCase()),
  );

  const tableHeaders = [
    { label: "#" },
    { label: "Vendor Name", Icon: RiStore2Line },
    { label: "Category", Icon: RiPriceTag3Line },
    { label: "Contact", Icon: RiUserLine },
    { label: "Phone", Icon: RiPhoneLine },
    { label: "Email", Icon: RiMailLine },
    { label: "Address", Icon: RiMapPinLine },
    { label: "Actions" },
  ];

  return (
    <div className="min-h-screen bg-white text-slate-800">
      {/* ── Header ── */}
      <header className="bg-white border-b border-blue-100 sticky top-0 z-30 shadow-sm">
        <div className="w-full mx-auto px-6 py-3.5 flex items-center justify-between gap-4 flex-wrap">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-blue-600 flex items-center justify-center text-white shadow-md shadow-blue-200">
              <RiStore2Line className="w-5 h-5" />
            </div>
            <div>
              <h1 className="text-base font-bold text-blue-800 tracking-tight">
                Branding Vendors
              </h1>
              <p className="text-[11px] text-blue-400 tracking-widest uppercase">
                Vendor Management
              </p>
            </div>
          </div>

          <div className="flex items-center gap-3 flex-wrap">
            {/* Category filter */}
            <div className="relative">
              <RiPriceTag3Line className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-blue-400 pointer-events-none" />
              <select
                value={filterCategory}
                onChange={(e) => setFilterCategory(e.target.value)}
                className="bg-blue-50 border border-blue-200 rounded-lg pl-9 pr-3 py-2 text-sm text-slate-700 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 w-44 transition appearance-none"
              >
                <option value="">All Categories</option>
                {categories.map((cat) => (
                  <option key={cat._id} value={cat._id}>
                    {cat.name}
                  </option>
                ))}
              </select>
            </div>

            {/* Search */}
            <div className="relative">
              <RiSearchLine className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-blue-400" />
              <input
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Search vendors..."
                className="bg-blue-50 border border-blue-200 rounded-lg pl-9 pr-3 py-2 text-sm text-slate-700 placeholder-blue-300 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 w-52 transition"
              />
            </div>

            {/* Refresh */}
            <button
              onClick={fetchVendors}
              disabled={loading}
              title="Refresh"
              className="w-9 h-9 flex items-center justify-center rounded-lg border border-blue-200 text-blue-400 hover:text-blue-600 hover:bg-blue-50 transition disabled:opacity-50"
            >
              <RiRefreshLine
                className={`w-4 h-4 ${loading ? "animate-spin" : ""}`}
              />
            </button>

            <button
              onClick={openCreate}
              className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold text-sm px-4 py-2 rounded-lg transition-all shadow-md shadow-blue-200"
            >
              <RiAddLine className="w-4 h-4" />
              Add Vendor
            </button>
          </div>
        </div>
      </header>

      {/* ── Table ── */}
      <div className="w-full mx-auto px-6 pt-6 pb-10">
        <div className="bg-white border border-blue-100 rounded-2xl overflow-hidden shadow-sm">
          <div className="px-5 py-3.5 border-b border-blue-50 bg-blue-50/50 flex items-center justify-between">
            <span className="text-sm font-semibold text-blue-800 flex items-center gap-2">
              <RiListCheck2 className="w-4 h-4 text-blue-500" />
              All Vendors
            </span>
            <span className="text-xs text-blue-400">
              {filtered.length} record{filtered.length !== 1 ? "s" : ""}
            </span>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-blue-100 bg-blue-50/30">
                  {tableHeaders.map(({ label, Icon }) => (
                    <th key={label} className="px-4 py-3 text-left">
                      <span className="flex items-center gap-1.5 text-xs font-semibold text-blue-500 uppercase tracking-widest whitespace-nowrap">
                        {Icon && <Icon className="w-3.5 h-3.5" />}
                        {label}
                      </span>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan={8} className="py-20 text-center">
                      <div className="flex flex-col items-center gap-3 text-blue-400">
                        <AiOutlineLoading3Quarters className="w-7 h-7 animate-spin text-blue-500" />
                        <span className="text-sm">Loading vendors…</span>
                      </div>
                    </td>
                  </tr>
                ) : filtered.length === 0 ? (
                  <tr>
                    <td colSpan={8} className="py-20 text-center">
                      <div className="flex flex-col items-center gap-3">
                        <div className="w-14 h-14 rounded-full bg-blue-50 border border-blue-100 flex items-center justify-center">
                          <RiStore2Line className="w-7 h-7 text-blue-300" />
                        </div>
                        <span className="text-sm text-slate-400">
                          {search || filterCategory
                            ? "No vendors match your filters."
                            : "No vendors found. Add one to get started."}
                        </span>
                      </div>
                    </td>
                  </tr>
                ) : (
                  filtered.map((vendor, i) => (
                    <tr
                      key={vendor._id || i}
                      className="border-b border-blue-50 hover:bg-blue-50/50 transition group"
                    >
                      <td className="px-4 py-3 text-slate-400 text-xs font-medium">
                        {i + 1}
                      </td>
                      <td className="px-4 py-3 font-semibold text-slate-800 whitespace-nowrap">
                        <div className="flex items-center gap-2">
                          <div className="w-7 h-7 rounded-lg bg-blue-600 flex items-center justify-center text-white text-xs font-bold shadow-sm shadow-blue-200 flex-shrink-0">
                            {(vendor.name || "?")[0].toUpperCase()}
                          </div>
                          {vendor.name || "—"}
                        </div>
                      </td>
                      <td className="px-4 py-3">
                        {vendor.category ? (
                          <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-blue-50 border border-blue-200 text-blue-600 text-xs font-semibold whitespace-nowrap">
                            <RiPriceTag3Line className="w-3 h-3" />
                            {vendor.category?.name || vendor.category}
                          </span>
                        ) : (
                          <span className="text-slate-300 text-xs italic">
                            —
                          </span>
                        )}
                      </td>
                      <td className="px-4 py-3 text-slate-600 whitespace-nowrap">
                        {vendor.contactPerson || "—"}
                      </td>
                      <td className="px-4 py-3 text-slate-500 whitespace-nowrap">
                        {vendor.phone || "—"}
                      </td>
                      <td className="px-4 py-3 text-slate-500 whitespace-nowrap">
                        {vendor.email || "—"}
                      </td>
                      <td className="px-4 py-3 text-slate-500 max-w-[180px] truncate">
                        {vendor.address || "—"}
                      </td>
                      <td className="px-4 py-3">
                        <div className="flex gap-2">
                          <button
                            onClick={() => openEdit(vendor)}
                            className="flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-lg bg-blue-50 border border-blue-200 text-blue-600 hover:bg-blue-100 font-semibold transition"
                          >
                            <RiEditLine className="w-3.5 h-3.5" /> Edit
                          </button>
                          <button
                            onClick={() => openDelete(vendor)}
                            className="flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-lg bg-red-50 border border-red-200 text-red-500 hover:bg-red-100 font-semibold transition"
                          >
                            <RiDeleteBinLine className="w-3.5 h-3.5" /> Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* ── Create Modal ── */}
      {modal === "create" && (
        <Modal
          title={
            <>
              <RiAddLine className="w-5 h-5 text-blue-500" /> Add New Vendor
            </>
          }
          onClose={closeModal}
        >
          <FormBody
            form={form}
            handleChange={handleChange}
            categories={remainingCategories}
            existingCategoryNames={existingCategoryNames}
          />
          <div className="flex justify-end gap-3 pt-2 border-t border-blue-50">
            <button
              onClick={closeModal}
              className="flex items-center gap-1.5 px-5 py-2 rounded-lg text-sm text-slate-500 hover:text-slate-700 border border-slate-200 hover:bg-slate-50 transition"
            >
              <RiCloseLine className="w-4 h-4" /> Cancel
            </button>
            <button
              onClick={handleCreate}
              disabled={actionLoading}
              className="flex items-center gap-2 px-5 py-2 rounded-lg text-sm font-semibold bg-blue-600 hover:bg-blue-700 text-white transition shadow-md shadow-blue-200 disabled:opacity-60"
            >
              {actionLoading ? (
                <Spinner />
              ) : (
                <RiCheckLine className="w-4 h-4" />
              )}
              Create{" "}
              {form.categories.length > 0 ? `(${form.categories.length})` : ""}{" "}
              Vendor
              {form.categories.length !== 1 ? "s" : ""}
            </button>
          </div>
        </Modal>
      )}

      {/* ── Edit Modal ── */}
      {modal === "edit" && (
        <Modal
          title={
            <>
              <RiEditLine className="w-5 h-5 text-blue-500" /> Edit —{" "}
              {selected?.name}
            </>
          }
          onClose={closeModal}
        >
          <FormBody
            form={form}
            handleChange={handleChange}
            categories={remainingCategories}
            existingCategoryNames={existingCategoryNames}
          />
          <div className="flex justify-end gap-3 pt-2 border-t border-blue-50">
            <button
              onClick={closeModal}
              className="flex items-center gap-1.5 px-5 py-2 rounded-lg text-sm text-slate-500 hover:text-slate-700 border border-slate-200 hover:bg-slate-50 transition"
            >
              <RiCloseLine className="w-4 h-4" /> Cancel
            </button>
            <button
              onClick={handleUpdate}
              disabled={actionLoading}
              className="flex items-center gap-2 px-5 py-2 rounded-lg text-sm font-semibold bg-blue-600 hover:bg-blue-700 text-white transition shadow-md shadow-blue-200 disabled:opacity-60"
            >
              {actionLoading ? (
                <Spinner />
              ) : (
                <RiCheckLine className="w-4 h-4" />
              )}
              Save Changes
            </button>
          </div>
        </Modal>
      )}

      {/* ── Delete Modal ── */}
      {modal === "delete" && (
        <Modal
          title={
            <>
              <RiDeleteBinLine className="w-5 h-5 text-red-500" /> Confirm
              Deletion
            </>
          }
          onClose={closeModal}
        >
          <div className="text-center py-4">
            <div className="w-16 h-16 rounded-full bg-red-50 border border-red-100 flex items-center justify-center mx-auto mb-4">
              <RiErrorWarningLine className="w-8 h-8 text-red-500" />
            </div>
            <p className="text-slate-700 font-semibold mb-1 text-base">
              Delete <span className="text-red-500">{selected?.name}</span>?
            </p>
            <p className="text-slate-400 text-sm mb-6">
              This action cannot be undone. This vendor will be permanently
              removed.
            </p>
            <div className="flex justify-center gap-3">
              <button
                onClick={closeModal}
                className="flex items-center gap-1.5 px-6 py-2 rounded-lg text-sm text-slate-500 border border-slate-200 hover:bg-slate-50 transition"
              >
                <RiCloseLine className="w-4 h-4" /> Cancel
              </button>
              <button
                onClick={handleDelete}
                disabled={actionLoading}
                className="flex items-center gap-2 px-6 py-2 rounded-lg text-sm font-semibold bg-red-500 hover:bg-red-600 text-white transition shadow-md shadow-red-100 disabled:opacity-60"
              >
                {actionLoading ? (
                  <Spinner />
                ) : (
                  <RiDeleteBinLine className="w-4 h-4" />
                )}
                Delete Vendor
              </button>
            </div>
          </div>
        </Modal>
      )}

      {toast && <Toast {...toast} onClose={() => setToast(null)} />}
    </div>
  );
}
